import React from 'react';
import { PureTranslator } from 'ggApp/modules/translator/components';
import PayPalWithP from 'ggApp/shared/icons/PayPal/WithP';
import { Root, ContentWrapper, Loader, Text } from './styles';

const PaypalRedirectPreflight = () => {
    return (
        <Root>
            <ContentWrapper>
                <Loader />
                <Text>
                    <PureTranslator tk="PAYMENT_REDIRECT_PREFLIGHT_MSG_PAYPAL" />
                </Text>
            </ContentWrapper>
            <PayPalWithP />
        </Root>
    );
};

export default PaypalRedirectPreflight;
